// // import { Component, OnInit } from '@angular/core';
// // import { CommonModule } from '@angular/common';
// // import {
// //   ReactiveFormsModule,
// //   FormBuilder,
// //   FormsModule,
// //   FormGroup,
// //   Validators,
// // } from '@angular/forms';
// // import { HttpClientModule, HttpClient } from '@angular/common/http';

// // @Component({
// //   selector: 'app-foreign-courses',
// //   standalone: true,
// //   templateUrl: './foreign-courses.component.html',
// //   styleUrls: ['./foreign-courses.component.scss'],
// //   imports: [CommonModule, ReactiveFormsModule, HttpClientModule, FormsModule],
// // })
// // export class ForeignCoursesComponent implements OnInit {
// //   adminName: string = 'Admin';
// //   adminImage: string = 'assets/admin.png';
// //   display = 'none';
// //   showAdd = false;
// //   courseForm!: FormGroup;

// //   countries: any[] = []; // loaded from /api/country -> expects { id, country }
// //   courses: any[] = []; // loaded from /api/foreign_course -> expects { course_id, course_name, country_id, country_name }
// //   grouped: {
// //     id: number;
// //     country_name: string;
// //     courses: any[];
// //     expanded?: boolean;
// //   }[] = [];

// //   // search filter text
// //   searchval: string = '';

// //   error_messages: any;

// //   constructor(private fb: FormBuilder, private http: HttpClient) {}

// //   ngOnInit(): void {
// //     this.buildForm();
// //     this.loadCountries();
// //     this.loadCourses();

// //     this.error_messages = {
// //       country: [{ type: 'required', message: 'Country is required' }],
// //       course_name: [{ type: 'required', message: 'Course name is required' }],
// //     };
// //   }

// //   buildForm() {
// //     this.courseForm = this.fb.group({
// //       country: ['', Validators.required],
// //       course_name: ['', Validators.required],
// //     });
// //   }

// //   loadCountries() {
// //     this.http.get<any>('https://smscap.in/api/country').subscribe({
// //       next: (res) => {
// //         // expects res.data to be array of { id, country }
// //         this.countries = res?.data || [];
// //         this.regroup(); // regroup in case courses already loaded
// //       },
// //       error: (err) => {
// //         console.error('loadCountries error', err);
// //         this.countries = [];
// //       },
// //     });
// //   }

// //   loadCourses() {
// //     this.http.get<any>('https://smscap.in/api/foreign_course').subscribe({
// //       next: (res) => {
// //         // expects res.data to be flat array like sample you provided
// //         this.courses = res?.data || [];
// //         this.regroup();
// //       },
// //       error: (err) => {
// //         console.error('loadCourses error', err);
// //         this.courses = [];
// //         this.regroup();
// //       },
// //     });
// //   }

// //   // builds `grouped` array used by template
// //   private regroup() {
// //     // We'll use country id where available; fallback to country_name string
// //     const map = new Map<
// //       string,
// //       { id: number; country_name: string; courses: any[] }
// //     >();

// //     // make a normalized map of countries from countries[] so we preserve order from that API when possible
// //     if (this.countries && this.countries.length) {
// //       for (const c of this.countries) {
// //         const key = String(c.id);
// //         map.set(key, { id: c.id, country_name: c.country, courses: [] });
// //       }
// //     }

// //     // Insert courses into map; if country id absent in map, add it by country_name
// //     for (const row of this.courses || []) {
// //       const cid = row.country_id ?? row.countryId ?? null;
// //       const countryName = (row.country_name ?? row.country ?? 'Unknown')
// //         .toString()
// //         .trim();

// //       const key = cid != null ? String(cid) : `name:${countryName}`;

// //       if (!map.has(key)) {
// //         map.set(key, { id: cid ?? -1, country_name: countryName, courses: [] });
// //       }
// //       map.get(key)!.courses.push(row);
// //     }

// //     // Convert Map to array preserving insertion order (countries defined first)
// //     this.grouped = Array.from(map.values()).map((g) => ({
// //       ...g,
// //       expanded: g.courses.length > 0 ? false : false, // default collapsed
// //     }));

// //     // apply search filter immediately if any
// //     if (this.searchval && this.searchval.trim()) {
// //       this.applySearchFilter(this.searchval.trim());
// //     }
// //   }

// //   // Template helper to get courses by country id (not used if template reads grouped)
// //   getCoursesByCountry(countryId: number) {
// //     return (this.courses || []).filter((c) => c.country_id === countryId);
// //   }

// //   // Expand/collapse toggle
// //   toggleCountry(group: any) {
// //     group.expanded = !group.expanded;
// //   }

// //   openAdd() {
// //     this.display = 'block';
// //     this.showAdd = true;
// //     this.courseForm.reset();
// //   }

// //   onCloseHandled() {
// //     this.display = 'none';
// //     this.courseForm.reset();
// //   }

// //   addCourse() {
// //     if (this.courseForm.invalid) {
// //       this.courseForm.markAllAsTouched();
// //       return;
// //     }

// //     const payload = {
// //       country_id: this.courseForm.value.country,
// //       course_name: this.courseForm.value.course_name,
// //     };

// //     // POST to API; on success refresh the list
// //     this.http.post('https://smscap.in/api/foreign_course', payload).subscribe({
// //       next: () => {
// //         this.loadCourses();
// //         this.onCloseHandled();
// //       },
// //       error: (err) => {
// //         console.error('addCourse error', err);
// //       },
// //     });
// //   }

// //   // search box handler (called on input)
// //   onQuickFilterChanged(val: string) {
// //     this.searchval = val ?? '';
// //     this.applySearchFilter(this.searchval.trim());
// //   }

// //   // clear search
// //   reset() {
// //     this.searchval = '';
// //     this.regroup();
// //   }

// //   // filters grouped results in-place (non-destructive: rebuild from original courses + countries)
// //   private applySearchFilter(q: string) {
// //     const lower = q.toLowerCase();

// //     if (!q) {
// //       this.regroup();
// //       return;
// //     }

// //     // rebuild grouping but only include matching countries/courses
// //     const map = new Map<
// //       string,
// //       { id: number; country_name: string; courses: any[] }
// //     >();

// //     // add countries to preserve order
// //     if (this.countries && this.countries.length) {
// //       for (const c of this.countries) {
// //         map.set(String(c.id), {
// //           id: c.id,
// //           country_name: c.country,
// //           courses: [],
// //         });
// //       }
// //     }

// //     for (const row of this.courses || []) {
// //       const cid = row.country_id ?? row.countryId ?? null;
// //       const countryName = (row.country_name ?? row.country ?? 'Unknown')
// //         .toString()
// //         .trim();
// //       const key = cid != null ? String(cid) : `name:${countryName}`;

// //       // match either course_name or country_name
// //       const matchesCourse = (row.course_name ?? '')
// //         .toString()
// //         .toLowerCase()
// //         .includes(lower);
// //       const matchesCountry = countryName.toLowerCase().includes(lower);

// //       if (matchesCourse || matchesCountry) {
// //         if (!map.has(key)) {
// //           map.set(key, {
// //             id: cid ?? -1,
// //             country_name: countryName,
// //             courses: [],
// //           });
// //         }
// //         map.get(key)!.courses.push(row);
// //       }
// //     }

// //     // convert and set expanded true for groups that have results (makes them visible)
// //     this.grouped = Array.from(map.values()).map((g) => ({
// //       ...g,
// //       expanded: g.courses.length > 0 ? true : false,
// //     }));
// //   }
// // }
// import { Component, OnInit } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import {
//   ReactiveFormsModule,
//   FormBuilder,
//   FormsModule,
//   FormGroup,
//   Validators,
// } from '@angular/forms';
// import { HttpClientModule, HttpClient } from '@angular/common/http';

// @Component({
//   selector: 'app-foreign-courses',
//   standalone: true,
//   templateUrl: './foreign-courses.component.html',
//   styleUrls: ['./foreign-courses.component.scss'],
//   imports: [CommonModule, ReactiveFormsModule, HttpClientModule, FormsModule],
// })
// export class ForeignCoursesComponent implements OnInit {
//   adminName: string = 'Admin';
//   adminImage: string = 'assets/admin.png';
//   display = 'none';
//   showAdd = false;
//   courseForm!: FormGroup;

//   // countries loaded from /api/country
//   countries: { id: number; country: string }[] = [];

//   // ONLY using foreign_course API response for the grouped view
//   courses: any[] = []; // expects objects like { course_id, course_name, country_id, country_name, ... }
//   grouped: { country_name: string; courses: any[]; expanded?: boolean }[] = [];

//   // search filter text
//   searchval: string = '';

//   error_messages: any;

//   constructor(private fb: FormBuilder, private http: HttpClient) {}

//   ngOnInit(): void {
//     this.buildForm();
//     this.loadCountries();
//     this.loadCourses();

//     this.error_messages = {
//       country_id: [{ type: 'required', message: 'Country is required' }],
//       course_name: [{ type: 'required', message: 'Course name is required' }],
//     };
//   }

//   buildForm() {
//     // Use country_id dropdown (select) in modal
//     this.courseForm = this.fb.group({
//       country_id: ['', Validators.required],
//       course_name: ['', Validators.required],
//     });
//   }

//   // load countries for the modal select
//   loadCountries() {
//     this.http.get<any>('https://smscap.in/api/country').subscribe({
//       next: (res) => {
//         // expects res.data to be array of { id, country }
//         this.countries = res?.data || [];
//       },
//       error: (err) => {
//         console.error('loadCountries error', err);
//         this.countries = [];
//       },
//     });
//   }

//   // load only foreign_course API for grid/list
//   loadCourses() {
//     this.http.get<any>('https://smscap.in/api/foreign_course').subscribe({
//       next: (res) => {
//         this.courses = res?.data || [];
//         this.regroup();
//       },
//       error: (err) => {
//         console.error('loadCourses error', err);
//         this.courses = [];
//         this.regroup();
//       },
//     });
//   }

//   // group by country_name (coming from foreign_course response)
//   private regroup() {
//     const map = new Map<string, { country_name: string; courses: any[] }>();

//     for (const row of this.courses || []) {
//       const countryName = (row.country_name ?? row.country ?? 'Unknown')
//         .toString()
//         .trim();
//       const key = countryName || 'Unknown';
//       if (!map.has(key)) {
//         map.set(key, { country_name: countryName, courses: [] });
//       }
//       map.get(key)!.courses.push(row);
//     }

//     this.grouped = Array.from(map.values()).map((g) => ({
//       ...g,
//       expanded: false,
//     }));

//     // apply search if present
//     if (this.searchval && this.searchval.trim()) {
//       this.applySearchFilter(this.searchval.trim());
//     }
//   }

//   // expand / collapse group
//   toggleCountry(group: any) {
//     group.expanded = !group.expanded;
//   }

//   openAdd() {
//     this.display = 'block';
//     this.showAdd = true;
//     this.courseForm.reset();
//   }

//   onCloseHandled() {
//     this.display = 'none';
//     this.courseForm.reset();
//   }

//   addCourse() {
//     if (this.courseForm.invalid) {
//       this.courseForm.markAllAsTouched();
//       return;
//     }

//     // POST expects country_id and course_name in many APIs,
//     // but foreign_course API shape may differ. We send both fields:
//     const payload: any = {
//       country_id: this.courseForm.value.country_id,
//       course_name: this.courseForm.value.course_name,
//     };

//     this.http.post('https://smscap.in/api/foreign_course', payload).subscribe({
//       next: () => {
//         this.loadCourses();
//         this.onCloseHandled();
//       },
//       error: (err) => {
//         console.error('addCourse error', err);
//       },
//     });
//   }

//   // search handler wired to input
//   onQuickFilterChanged(val: string) {
//     this.searchval = val ?? '';
//     this.applySearchFilter(this.searchval.trim());
//   }

//   // clear search and rebuild groups
//   reset() {
//     this.searchval = '';
//     this.regroup();
//   }

//   // filter grouped results in-memory by course_name or country_name
//   private applySearchFilter(q: string) {
//     const lower = q.toLowerCase();
//     if (!q) {
//       this.regroup();
//       return;
//     }

//     const map = new Map<string, { country_name: string; courses: any[] }>();

//     for (const row of this.courses || []) {
//       const countryName = (row.country_name ?? row.country ?? 'Unknown')
//         .toString()
//         .trim();
//       const key = countryName || 'Unknown';

//       const matchesCourse = (row.course_name ?? '')
//         .toString()
//         .toLowerCase()
//         .includes(lower);
//       const matchesCountry = countryName.toLowerCase().includes(lower);

//       if (matchesCourse || matchesCountry) {
//         if (!map.has(key)) {
//           map.set(key, { country_name: countryName, courses: [] });
//         }
//         map.get(key)!.courses.push(row);
//       }
//     }

//     this.grouped = Array.from(map.values()).map((g) => ({
//       ...g,
//       expanded: true,
//     }));
//   }
// }
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormsModule,
  FormGroup,
  Validators,
} from '@angular/forms';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-foreign-courses',
  standalone: true,
  templateUrl: './foreign-courses.component.html',
  styleUrls: ['./foreign-courses.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, HttpClientModule, FormsModule],
})
export class ForeignCoursesComponent implements OnInit {
  adminName: string = 'Admin';
  adminImage: string = 'assets/admin.png';
  display = 'none';
  showAdd = false;
  courseForm!: FormGroup;

  // countries loaded from /api/country
  countries: { id: number; country: string }[] = [];

  // only using foreign_course API response for the grouped view
  courses: any[] = []; // expects objects like { course_id, course_name, country_id, country_name, ... }
  grouped: { country_name: string; courses: any[]; expanded?: boolean }[] = [];

  // search filter text
  searchval: string = '';

  // holds validation messages (optional)
  error_messages: any;

  // track deleting row by id for UI/disable state
  deletingId: string | number | null = null;

  constructor(private fb: FormBuilder, private http: HttpClient) {}

  ngOnInit(): void {
    this.buildForm();
    this.loadCountries();
    this.loadCourses();

    this.error_messages = {
      country_id: [{ type: 'required', message: 'Country is required' }],
      course_name: [{ type: 'required', message: 'Course name is required' }],
    };
  }

  buildForm() {
    // Use country_id dropdown (select) in modal
    this.courseForm = this.fb.group({
      country_id: ['', Validators.required],
      course_name: ['', Validators.required],
    });
  }

  // load countries for the modal select
  loadCountries() {
    this.http.get<any>('https://smscap.in/api/country').subscribe({
      next: (res) => {
        // expects res.data to be array of { id, country }
        this.countries = res?.data || [];
      },
      error: (err) => {
        console.error('loadCountries error', err);
        this.countries = [];
      },
    });
  }

  // load only foreign_course API for grid/list
  loadCourses() {
    this.http.get<any>('https://smscap.in/api/foreign_course').subscribe({
      next: (res) => {
        this.courses = res?.data || [];
        this.regroup();
      },
      error: (err) => {
        console.error('loadCourses error', err);
        this.courses = [];
        this.regroup();
      },
    });
  }

  // group by country_name (coming from foreign_course response)
  private regroup() {
    const map = new Map<string, { country_name: string; courses: any[] }>();

    for (const row of this.courses || []) {
      const countryName = (row.country_name ?? row.country ?? 'Unknown')
        .toString()
        .trim();
      const key = countryName || 'Unknown';
      if (!map.has(key)) {
        map.set(key, { country_name: countryName, courses: [] });
      }
      map.get(key)!.courses.push(row);
    }

    this.grouped = Array.from(map.values()).map((g) => ({
      ...g,
      expanded: false,
    }));

    // apply search if present
    if (this.searchval && this.searchval.trim()) {
      this.applySearchFilter(this.searchval.trim());
    }
  }

  // expand / collapse group
  toggleCountry(group: any) {
    group.expanded = !group.expanded;
  }

  openAdd() {
    this.display = 'block';
    this.showAdd = true;
    this.courseForm.reset();
  }

  onCloseHandled() {
    this.display = 'none';
    this.courseForm.reset();
  }

  addCourse() {
    if (this.courseForm.invalid) {
      this.courseForm.markAllAsTouched();
      return;
    }

    const payload: any = {
      country_id: this.courseForm.value.country_id,
      course_name: this.courseForm.value.course_name,
    };

    this.http.post('https://smscap.in/api/foreign_course', payload).subscribe({
      next: () => {
        // refresh courses from server
        this.loadCourses();
        this.onCloseHandled();
      },
      error: (err) => {
        console.error('addCourse error', err);
        window.alert('Failed to add course. See console for details.');
      },
    });
  }

  // search handler wired to input
  onQuickFilterChanged(val: string) {
    this.searchval = val ?? '';
    this.applySearchFilter(this.searchval.trim());
  }

  // clear search and rebuild groups
  reset() {
    this.searchval = '';
    this.regroup();
  }

  // filter grouped results in-memory by course_name or country_name
  private applySearchFilter(q: string) {
    const lower = q.toLowerCase();
    if (!q) {
      this.regroup();
      return;
    }

    const map = new Map<string, { country_name: string; courses: any[] }>();

    for (const row of this.courses || []) {
      const countryName = (row.country_name ?? row.country ?? 'Unknown')
        .toString()
        .trim();
      const key = countryName || 'Unknown';

      const matchesCourse = (row.course_name ?? '')
        .toString()
        .toLowerCase()
        .includes(lower);
      const matchesCountry = countryName.toLowerCase().includes(lower);

      if (matchesCourse || matchesCountry) {
        if (!map.has(key)) {
          map.set(key, { country_name: countryName, courses: [] });
        }
        map.get(key)!.courses.push(row);
      }
    }

    this.grouped = Array.from(map.values()).map((g) => ({
      ...g,
      expanded: true,
    }));
  }

  // DELETE course
  deleteCourse(course: any) {
    const id = course.course_id ?? course.id ?? course.courseId;
    if (id == null) {
      console.error('deleteCourse: unable to determine id for', course);
      window.alert('Unable to determine the id of the course to delete.');
      return;
    }

    const ok = window.confirm(
      `Delete course "${course.course_name}"? This action cannot be undone.`
    );
    if (!ok) return;

    this.deletingId = id;

    const params = new HttpParams().set('id', String(id));

    this.http
      .delete('https://smscap.in/api/foreign_course', { params })
      .subscribe({
        next: () => {
          // Option A: reload from server for canonical state
          this.loadCourses();

          // Option B (optimistic UI) - uncomment instead of loadCourses()
          // this.courses = (this.courses || []).filter(r => (r.course_id ?? r.id ?? r.courseId) !== id);
          // this.regroup();

          this.deletingId = null;
        },
        error: (err) => {
          console.error('deleteCourse error', err);
          window.alert('Failed to delete course. See console for details.');
          this.deletingId = null;
        },
      });
  }
}
